// src/hooks/usePermission.js
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isS2Admin } from '../globalFunctions';
import permissionManager from '../permissionManager';

export const useModulePermission = (requiredPermission) => {
  const user = useSelector((state) => state.user);
  const userHasRoleWithPermission = useSelector((state) => state.userHasRoleWithPermission);
  const currentSwitchedSociety = useSelector((state) => state.switchedSociety);
  const switchedRole = useSelector((state) => state.switchedRole);

  return useMemo(() => {
    // If user is S2Admin, return all permissions as true
    if (isS2Admin(user)) {
      return {
        isRead: true,
        isWrite: true,
        hasAccess: true
      };
    }

    const { permissions } = permissionManager.getPermissions(
      userHasRoleWithPermission,
      user,
      currentSwitchedSociety?._id,
      switchedRole?.accessTypeId
    );

    const permission = permissions.find(
      permission => permission.moduleName === requiredPermission
    );

    return {
      isRead: permission?.permissionType?.includes("read") || false,
      isWrite: permission?.permissionType === "read-write" || false,
      hasAccess: !!permission
    };
  }, [user, userHasRoleWithPermission, currentSwitchedSociety, switchedRole, requiredPermission]);
};